import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import './figma/tokens/tokens.css';
import './figma/tokens/typography.css';
import './styles/global.css';
import './styles/auth-responsive.css';
import './styles/cabinet-tablet.css';
import './styles/tablet-shell.css';
import './styles/landing-feedback.css';
import { AuthProvider } from './state/auth';
import { ChatStatusProvider } from './state/chatStatus';
import { LanguageProvider } from './i18n/LanguageProvider';

const root = document.getElementById('root');

if (!root) throw new Error('LOVO root element was not found');

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <ChatStatusProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </ChatStatusProvider>
    </AuthProvider>
  </StrictMode>,
);
